<template>
    <div class="loading" v-show="mask">
      <i :class="`el-icon-loading ${icon ? 'load-top-50' : 'load-top-0'}`"></i>
    </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  data() {
    return {
      mask: false,
      icon: false
    }
  },
  computed: {
    ...mapState(['loading'])
  },
  watch: {
    loading(nV) {
      if(nV) {
        this.mask = true
        setTimeout(() => {
          this.icon = true
        },80)
      }else {
        this.icon = false
        setTimeout(() => this.mask = false,350)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
 
  i {
    display: block;
    position: absolute;
    // font-weight: bold;
    left: 50%;
    top: 35px;
    transform: translateX(-50%);
    color: #ebb563;
    font-size: 25px;
    transition: all .2s;
  }
}
.load-top-50 {
  opacity: 1 !important;
}
.load-top-0 {
  opacity: .6 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Util/LoadingUtil.vue